// router.js
/* eslint-disable import/prefer-default-export */

import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/pages/Home.vue';
import Teaser from '@/pages/Teaser.vue';
import Player from '@/pages/Player.vue';
import StoreLocator from '@/pages/StoreLocator.vue';
import Zoom from '@/components/popins/Zoom.vue';

const mdpConfig = require('../mdp.config');

// Routes names should match the data's config first level key names
// in order to use the shorten $content computed property. ex: "home"
function getRoutes({ locale }) {
  const isEN = locale === 'en'; // eslint-disable-line no-unused-vars
  return [
    {
      path: '/',
      name: 'home',
      component: Home,
      children: [
        {
          path: 'zoom/:id', component: Zoom, name: 'zoom', meta: { name: 'home' },
        },
      ],
    },
    {
      path: '/teaser',
      name: 'teaser',
      component: Teaser,
      children: [
        {
          path: 'zoom/:id', component: Zoom, name: 'zoom-teaser', meta: { name: 'home' },
        },
      ],
    },
    // Movies will be dinstinguished by their route name
    {
      path: '/film',
      name: 'movie',
      component: Player,
    },
    {
      path: '/savoir-faire',
      name: 'knowhow',
      component: Player,
    },
    {
      path: '/store-locator',
      name: 'store',
      component: StoreLocator,
    },
    // ################################################################################
    // KEEP THIS LAST
    // This is a catch-all route that redirects to the home page
    // It should be the last route in the array to avoid conflicts with other routes
    // ################################################################################
    {
      path: '*',
      redirect: '/',
    },
  ];
}

Vue.use(Router);

export function createRouter(version) {
  const config = mdpConfig[version];
  const routes = getRoutes({ ...config, locale: version });
  return new Router({
    routes,
    scrollBehavior({ name: nameTo }, { name: nameFrom }, savedPosition) {
      const behavior = nameFrom === 'home' ? 'instant' : 'smooth';
      const appWrapper = document.querySelector('#app-wrapper');
      const offset = appWrapper ? appWrapper.getBoundingClientRect().top : 0;
      if (nameTo === 'zoom' || nameFrom === 'zoom') {
        return savedPosition;
      }
      return { y: offset, behavior };
    },
  });
}
